$(document).ready(function () {
  const filters = $("#projects-filters");
  const filtersBtn = $("#projects-filter-toggle");
  const closeFilters = $("#close-projects-filter");
  // var GtmEvents = require("./seo/gtmEvents");
  filtersBtn && filtersBtn.click(e => {
    const btn = $(e.currentTarget);
    btn.toggleClass("active");
    if (btn.hasClass("active")) {
      filters.addClass("visible");
    } else {
      filters.removeClass("visible");
    }
  });
  filters && filters.find(".js-filter-trigger").click(e => {
    const link = $(e.currentTarget);
    if (link.hasClass("active")) {
      e.preventDefault();
      window.location = link.data("reset");
    } else {
      // GTM
      // const projectName = link[0].innerText.toLowerCase();
      // GtmEvents.onSelectFilter(projectName);
      window.location = link.data("href");
    }
  });
  closeFilters && closeFilters.click(() => {
    filtersBtn.removeClass("active");
    filters.removeClass("visible");
  });
});